import { NavLink } from "react-router-dom";
import { BOTTOM_NAV_HEIGHT, THEME_COLOR } from "../../config/club";

export default function BottomNav() {
  return (
    <nav
      className="position-fixed bottom-0 start-0 w-100"
      style={{
        height: BOTTOM_NAV_HEIGHT,
        zIndex: 1000,
        backgroundColor: "var(--card-bg)",
        borderTop: "1px solid var(--border-color)",
        boxShadow: "0 -2px 20px rgba(0,0,0,0.25)",
        backdropFilter: "blur(10px)"
      }}
    >
      <div className="d-flex justify-content-around align-items-center h-100">
        <NavItem to="/" icon="bi-house" label="Home" />
        <NavItem to="/reservations" icon="bi-calendar-check" label="Join" />
        <NavItem to="/rankings" icon="bi-trophy" label="Rankings" />
        {/* <NavItem to="/tournament" icon="bi-calendar-event" label="Tournament" /> */}
        <NavItem to="/me" icon="bi-person" label="Me" />
      </div>
    </nav>
  );
}

function NavItem({ to, icon, label }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        textDecoration: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        fontSize: "0.7rem",
        fontWeight: isActive ? 700 : 500,
        color: isActive ? THEME_COLOR : "var(--muted-text)",
        transition: "0.2s"
      })}
    >
      {({ isActive }) => (
        <>
          <i
            className={`bi ${icon}`}
            style={{
              fontSize: "1.3rem",
              color: isActive ? THEME_COLOR : "var(--muted-text)"
            }}
          />
          {label}
        </>
      )}
    </NavLink>
  );
}